import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-turns-desk-new-schedule-dashboard',
  templateUrl: './turns-desk-new-schedule-dashboard.component.html',
  styleUrls: ['./turns-desk-new-schedule-dashboard.component.scss']
})
export class TurnsDeskNewScheduleDashboardComponent implements OnInit {

  deskid;

  constructor(private activatedRoute: ActivatedRoute,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.deskid = this.activatedRoute.snapshot.params['deskid'];
    this.setBreadcrumb();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-calendar-day', 'schedule-page.new schedule', '/turns/desk/' + this.deskid, [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.desk detail', '/turns/desk/' + this.deskid), new BRoute('schedule-page.new schedule')]));
  }
}
